export default __webpack_public_path__ + "static/media/MapsMarker.45e61aed.jpeg";